// ⚠️ ALERT, coder! These macros are tested in the `@watershed/domain` workspace,
// so we can use DuckDB to verify the test results. Look for `duckMacros.test.ts`.

import dedent from 'ts-dedent';

export const dateMacros = [
  dedent`
    CREATE OR REPLACE TEMP MACRO datetime_cast_int(x) AS
    CASE
      WHEN x >= 197000 AND x < 300000 THEN
        make_timestamp(x // 100, x % 100, 1, 0, 0, 0)
      WHEN x >= 300000000 AND x <= 30000000000 THEN
        epoch_ms(x * 1000)
      WHEN x >= 300000000000 AND x <= 30000000000000 THEN
        epoch_ms(x)
      ELSE
        NULL
    END
  `,

  dedent`
    CREATE OR REPLACE TEMP MACRO datetime_cast_str(x) AS
    CASE
      WHEN regexp_matches(x, '^\\d{4}-\\d{2}-\\d{2}$') THEN
        cast(x AS TIMESTAMP)
      WHEN regexp_matches(x, '^\\d{4}-\\d{2}$') THEN
        cast(x || '-01' AS TIMESTAMP)
      WHEN regexp_matches(x, '^\\d{4}-\\d{2}-\\d{2} \\d{2}:\\d{2}:\\d{2}') THEN
        cast(x AS TIMESTAMP)
      WHEN regexp_matches(x, '^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z?') THEN
        cast(x AS TIMESTAMP)
      WHEN regexp_matches(x, '^\\d{10}$') THEN
        datetime_cast_int(cast(x AS BIGINT))
      WHEN regexp_matches(x, '^\\d{13}$') THEN
        datetime_cast_int(cast(x AS BIGINT))
      ELSE
        NULL
    END
  `,

  dedent`
    CREATE OR REPLACE TEMP MACRO datetime_cast(x) AS
    CASE
      WHEN x IS NULL THEN
        NULL
      WHEN typeof(x) = 'DATE' THEN
        cast(x AS DATE)
      WHEN typeof(x) in ('TIMESTAMP', 'TIMESTAMP WITH TIME ZONE') THEN
        cast(x AS TIMESTAMP)
      WHEN typeof(x) = 'VARCHAR' THEN
        datetime_cast_str(cast(x AS VARCHAR))
      WHEN typeof(x) IN ('INTEGER', 'BIGINT', 'SMALLINT', 'TINYINT', 'FLOAT', 'DOUBLE', 'DECIMAL') THEN
        datetime_cast_int(cast(x AS BIGINT))
      ELSE
        NULL
    END
  `,

  dedent`
    CREATE OR REPLACE TEMP MACRO date_cast(x) AS
    cast(datetime_cast(x) AS DATE)
  `,
];

export const ymToDateMacro = dedent`
  CREATE OR REPLACE TEMP MACRO ym_to_date(x) AS
  make_date(cast(x AS BIGINT) // 100, cast(x AS BIGINT) % 100, 1);
`;

// Rounds to the specified  number of significant digits (instead of a number of
// decimal places). For the formula, see
// https://en.wikipedia.org/wiki/Significant_figures#Rounding_to_significant_figures
export const sfroundMacro = dedent`
  CREATE OR REPLACE TEMP MACRO sfround(x, y) AS
  CASE
    WHEN y = 0 THEN 0
    WHEN x = 0 THEN 0
    ELSE round(x, y - 1  - abs(x).log10().floor()::INTEGER)
  END;
`;
